// extracted by mini-css-extract-plugin
export default {"base":"styles-module--base--whH0i","title":"styles-module--title--dAgLd","image":"styles-module--image--a0zd9","more":"styles-module--more--ZC+UJ"};